// Generated by genversion.
export const version = '4.35.0';
